import "./Contact.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import ParlonsDeVotreProjet from "./sections/ParlonsDeVotreProjet";
import FormulaireDeConsultation from "./sections/FormulaireDeConsultation";
import NosBureauxALyon from "./sections/NosBureauxALyon";
import PiedDePage from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavigationHeader />
      <ParlonsDeVotreProjet />
      <FormulaireDeConsultation />
      <NosBureauxALyon />
      <PiedDePage />
    </div>;
}